;(function() {
  'use strict'

  controller.$inject = ["$transitions", "$scope", "glDialog", "facesService", "userService", "messageService"];
  angular
    .module('app.messageSendDialog')
    .controller('MessageSendDialog', controller)

  /* @ngInject */
  function controller(
    $transitions,
    $scope,
    glDialog,
    facesService,
    userService,
    messageService
  ) {
    var message

    // close dialog if we route away
    $transitions.onStart(null, function() {
      $scope.dialog.cancel()
    })

    $scope.data = $scope.data || {}
    $scope.isLoggedIn = !!userService.get().id
    $scope.trySend = trySend
    $scope.send = send
    $scope.getFace = getFace
    $scope.validForm = validForm
    $scope.emailChecker = $scope.emailChecker || userService.getEmailChecker()
    $scope.login = login
    $scope.moods = facesService.get()
    $scope.selectedMoodStyle = selectedMoodStyle

    $scope.types = [
      { label: 'Feedback', value: 'feedback', icon: 'gi-chat' },
      { label: 'Idea', value: 'idea', icon: 'gi-idea' },
      { label: 'Complaint', value: 'complaint', icon: 'gi-complaint' },
      { label: 'Praise', value: 'praise', icon: 'gi-praise' },
      { label: 'Suggestion', value: 'suggestion', icon: 'gi-suggestion' },
      { label: 'Request', value: 'request', icon: 'gi-request' },
      { label: 'Question', value: 'question', icon: 'gi-question' },
    ]

    init()

    function init() {
      $scope.message = message =
        $scope.message || messageService.create($scope.options)
    }

    function trySend() {
      delete $scope.data.error

      if ($scope.data.email) {
        message.isSaving = true
        userService.signupEmail($scope.data.email, $scope.data.fullname).then(
          function(emailUser) {
            message.isSaving = false
            send(emailUser)
          },
          function() {
            message.isSaving = false
            $scope.data.error =
              'Error sending message. Please check your info and try again.'
          }
        )
      } else {
        send()
      }
    }

    function send(emailUser) {
      // send the message
      message.save({ auth: emailUser }).then(
        function() {
          $scope.dialog.close()
          showThanks()
          // return glDialog.show({
          //     templateUrl: 'community-dialog.template.html',
          //     controller: 'CommunityDialog',
          //     escapeToClose: false,
          //     locals: {
          //         emailUser: emailUser,
          //         element: $scope.element, // TODO what if page?
          //         page: $scope.page,
          //         onClose: showThanks
          //     }
          // });
        },
        function() {
          $scope.data.error =
            'Error sending message. Please check your info and try again.'
        }
      )

      function showThanks() {
        return glDialog.show({
          templateUrl: 'dialog-orangealert.template.html',
          controller: function() {},
          escapeToClose: true,
          locals: {
            title: 'Message Sent',
            message:
              'Thank-you for your feedback. We have sent it to the right people!',
          },
        })
      }
    }

    function validForm() {
      if (message.getErrors()) {
        return false
      }

      if ($scope.data.email && $scope.emailChecker.state !== 'available') {
        return false
      }

      return true
    }

    function getFace(value) {
      return _.findWhere(facesService.get(), { value: value })
    }

    function login() {
      delete $scope.data.error

      userService.showLogin(null, { prefillEmail: $scope.data.email }).then(
        function() {
          resumeNewMessage(true)
        },
        function() {
          resumeNewMessage(false)
        }
      )
      $scope.dialog.close()

      function resumeNewMessage(didLogin) {
        if (didLogin) {
          $scope.data.email = null
        }
        glDialog.show({
          templateUrl: 'message-send-dialog.template.html',
          escapeToClose: false,
          controller: 'MessageSendDialog',
          locals: {
            options: $scope.options,
            message: $scope.message,
            data: $scope.data,
            emailChecker: didLogin ? null : $scope.emailChecker,
          },
        })
      }
    }

    function selectedMoodStyle(mood) {
      var isSelected =
        $scope.message.moodEntry && $scope.message.moodEntry === mood.value
      if (isSelected) {
        return { color: mood.color }
      }
    }
  }
})()
